<template>
    <Calendar id="range"
              :value="modelValue"
              @input="$emit('update:modelValue', $event.target.value)"
              @update:modelValue="$emit('update:modelValue', $event)"
              dateFormat="dd.mm.yy"
              selectionMode="range"
              :placeholder="$t('ranges.placeholder')"
              :manualInput="true">
        <template #footer>
            <div class="flex flex-col">
                <link-button @click="setToday">{{ $t('ranges.today') }}</link-button>
                <link-button @click="setLastSeven">{{ $t('ranges.last7') }}</link-button>
                <link-button @click="setThisMonth">{{ $t('ranges.thisMonth') }}</link-button>
                <link-button @click="setLastMonth">{{ $t('ranges.lastMonth') }}</link-button>
                <link-button @click="setThisYear">{{ $t('ranges.thisYear') }}</link-button>
            </div>
        </template>
    </Calendar>
</template>

<script>
import Calendar from "primevue/calendar";
import moment from "moment";
import LinkButton from "@/Jetstream/LinkButton";

export default {
    props: ['modelValue'],
    emits: ['update:modelValue'],
    components: {
        LinkButton,
        Calendar
    },
    methods: {
        setToday() {
            this.$emit('update:modelValue', [moment().startOf('day').toDate(), moment().endOf('day').toDate()])
        },
        setLastSeven() {
            const from = moment().subtract(7, 'days').startOf('day').toDate();
            this.$emit('update:modelValue', [from, moment().endOf('day').toDate()])
        },
        setThisMonth() {
            const from = moment().startOf('month').toDate();
            const to = moment().endOf('month').toDate();
            this.$emit('update:modelValue', [from, to])
        },
        setLastMonth() {
            const from = moment().subtract(1, 'month').startOf('month');
            const to = from.clone().endOf('month')
            this.$emit('update:modelValue', [from.toDate(), to.toDate()])
        },
        setThisYear() {
            const from = moment().startOf('year');
            const to = moment().endOf('year')
            this.$emit('update:modelValue', [from.toDate(), to.toDate()])
        }
    }
}
</script>

<style scoped>

</style>
